import * as React from "react";

import { LoggerService } from "@/shared/services/LoggerService";

interface IFileTransferContext {
  // Parse the event data for files, and upload the files to the backend
  beginFileUpload: (
    event: React.DragEvent<HTMLElement> | React.ChangeEvent<HTMLInputElement>,
    orgId: string,
    datasetId: string,
    prefix?: string,
  ) => Promise<void>;
  isUploading: boolean;
  /**
   * Export files or directories as one ZIP, tracked in the transfer toast as
   * `label`. The toast opens on the call; the ZIP downloads when it is ready.
   */
  beginExport: (nodeIds: string[], label: string) => void;
}

export const FileTransferContext = React.createContext<IFileTransferContext>({
  beginFileUpload() {
    LoggerService.log("TODO: WRAP IN VALID FILE TRANSFER PROVIDER");
    return Promise.resolve();
  },
  isUploading: false,
  beginExport() {
    LoggerService.log("TODO: WRAP IN VALID FILE TRANSFER PROVIDER");
  },
});

export const useFileTransfer = (): IFileTransferContext => {
  return React.useContext(FileTransferContext);
};
